<template>
  <div>供应链协同平台</div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
